import { SocialLinks } from 'social-links';

import { CustomSocialLinks, CustomSocialLinksProfile, CustomSocialLinksProfileMatcher } from './custom-social-links/CustomSocialLinks';
import { ParseSocialResult } from './ParseSocialResult';

/** A wrapper on top of SocialLinks to support phone numbers */
export class SocialLinksAdaptor {
  private socialLinks = new SocialLinks({
    usePredefinedProfiles: true,
    trimInput: true,
    allowQueryParams: true,
  });

  private customSocialLinks = new CustomSocialLinks();

  // If we need to do anything other than add profiles.
  // Really would be good use some IOC here, but it's overkill
  getCustomAdapator() {
    return this.customSocialLinks;
  }

  addCustomProfile(profile: string, matches: CustomSocialLinksProfileMatcher[]);
  addCustomProfile(profile: CustomSocialLinksProfile);

  addCustomProfile(profile: any, matches?: CustomSocialLinksProfileMatcher[]) {
    this.customSocialLinks.addProfile(profile, matches);
  }


  parseSocial(profile: string, input: string): ParseSocialResult {
    const sl = this.selectAdaptor(profile);
    const isValid = sl.isValid(profile, input);
    try {
      const profileId = sl.getProfileId(profile, input);
      const sanitized = sl.sanitize(profile, input);
      return { profile, profileId, isValid, sanitized };
    } catch (e) {
      return { profile, profileId:input, isValid: false };
    }
  }

  private selectAdaptor(profile: string): SocialLinks | CustomSocialLinks {
    if (this.socialLinks.hasProfile(profile)) {
      return this.socialLinks;
    }
    if (this.customSocialLinks.hasProfile(profile)) {
      return this.customSocialLinks;
    }

    throw new Error(`No parser for social media profile type: ${profile}`);
  }
}
